import { render } from "./ProjectSiteList.vue?vue&type=template&id=674fdaca"
import script from "./ProjectSiteList.vue?vue&type=script&lang=js"
export * from "./ProjectSiteList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/project/project/ProjectSiteList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "674fdaca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('674fdaca', __exports__)) {
    api.reload('674fdaca', __exports__)
  }
  
  module.hot.accept("./ProjectSiteList.vue?vue&type=template&id=674fdaca", () => {
    api.rerender('674fdaca', render)
  })

}


export default __exports__